const VISIBLE_CHARACTERS = 4;

const maskApiKey = (apiKey) =>
  "*".repeat(Math.max(apiKey.length - VISIBLE_CHARACTERS, 0)) + apiKey.slice(-VISIBLE_CHARACTERS);

export default maskApiKey;
